<template>
  <Base icon="mdi-city" :satisfied="groupSatisfied || requirement.satisfied" tooltip>
    <span>
      Industry
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} have experience in the
      <strong>{{ requirement.value }}</strong> industry
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    first: { type: Boolean },
    groupSatisfied: { type: Boolean },
    requirement: { type: Object, required: true },
  },
}
</script>
